import React from "react";
import "./About.css";
import Header from "../Header/Header";
import { FaGraduationCap, FaBookOpen, FaUsers, FaAward, FaHeart, FaLightbulb } from 'react-icons/fa';

const About = () => {
  return (
    <div className="about-page">
      <Header />
      
      {/* 🔹 Hero Banner Section */}
      <section className="about-hero">
        <div className="hero-overlay">
          <div className="container">
            <div className="hero-content">
              <h1>About <span>Alasar Academy</span></h1>
              <p>
                Where knowledge meets spirituality — empowering minds with modern
                education rooted in Islamic values.
              </p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Students</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Teachers</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">8</span>
                  <span className="stat-label">Years</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">95%</span>
                  <span className="stat-label">Success Rate</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 Mission & Vision Section */}
      <section className="mission-vision">
        <div className="container">
          <div className="section-header">
            <h2>Our Mission & Vision</h2>
            <p>Guiding principles that shape our educational approach</p>
          </div>
          
          <div className="mission-grid">
            <div className="mission-card">
              <div className="card-icon">
                <FaGraduationCap />
              </div>
              <h3>Our Mission</h3>
              <p>
                To provide quality education that combines academic excellence with 
                Islamic values, nurturing students who are intellectually sharp, 
                morally upright, and spiritually aware.
              </p>
            </div>
            
            <div className="mission-card">
              <div className="card-icon">
                <FaLightbulb />
              </div>
              <h3>Our Vision</h3>
              <p>
                To be a leading educational institution that produces future leaders 
                who contribute positively to society while maintaining strong Islamic 
                principles and values.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 About Content Section */}
      <section className="about-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2>Introduction</h2>
              <p>
                Alasar Academy is a beacon of learning and moral excellence. Our
                approach blends modern education with Islamic principles, nurturing
                students who are intellectually sharp and spiritually aware.
              </p>
              <p>
                We believe in holistic development that encompasses academic achievement,
                character building, and spiritual growth. Our dedicated faculty works
                tirelessly to create an environment where every student can thrive.
              </p>
              <div className="features-list">
                <div className="feature-item">
                  <FaBookOpen className="feature-icon" />
                  <span>Comprehensive Curriculum</span>
                </div>
                <div className="feature-item">
                  <FaUsers className="feature-icon" />
                  <span>Experienced Faculty</span>
                </div>
                <div className="feature-item">
                  <FaHeart className="feature-icon" />
                  <span>Islamic Values</span>
                </div>
                <div className="feature-item">
                  <FaAward className="feature-icon" />
                  <span>Academic Excellence</span>
                </div>
              </div>
            </div>
            <div className="content-image">
              <img src="/api/placeholder/500/400" alt="Alasar Academy" />
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 History Section */}
      <section className="history-section">
        <div className="container">
          <div className="history-content">
            <div className="history-image">
              <img src="/api/placeholder/500/400" alt="School History" />
            </div>
            <div className="history-text">
              <h2>Our History</h2>
              <p>
                Established in 2015, Alasar Academy began as a small classroom with a
                powerful dream — to provide balanced education that unites worldly
                knowledge and eternal wisdom.
              </p>
              <p>
                Today, we stand as a symbol of academic success and moral strength,
                having grown from humble beginnings to become a respected institution
                in our community.
              </p>
              <div className="timeline">
                <div className="timeline-item">
                  <div className="timeline-year">2015</div>
                  <div className="timeline-content">
                    <h4>Foundation</h4>
                    <p>Alasar Academy was established with a vision for quality education</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-year">2018</div>
                  <div className="timeline-content">
                    <h4>Expansion</h4>
                    <p>New facilities and programs were added to serve more students</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-year">2023</div>
                  <div className="timeline-content">
                    <h4>Recognition</h4>
                    <p>Achieved recognition for academic excellence and community service</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 Achievements Section */}
      <section className="achievements-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Achievements</h2>
            <p>Celebrating our students' success and institutional milestones</p>
          </div>
          
          <div className="achievements-grid">
            <div className="achievement-card">
              <div className="achievement-icon">
                <FaAward />
              </div>
              <h3>Academic Excellence</h3>
              <p>95% of our students achieve excellent grades in board examinations</p>
            </div>
            
            <div className="achievement-card">
              <div className="achievement-icon">
                <FaUsers />
              </div>
              <h3>Community Service</h3>
              <p>Our students actively participate in community development programs</p>
            </div>
            
            <div className="achievement-card">
              <div className="achievement-icon">
                <FaGraduationCap />
              </div>
              <h3>Leadership Development</h3>
              <p>Graduates excel in various fields and contribute to society</p>
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 Commitment Section */}
      <section className="commitment-section">
        <div className="container">
          <div className="commitment-content">
            <h2>Our Commitment</h2>
            <p>
              Inspiring excellence, strengthening faith, and building the leaders of
              tomorrow — Alasar Academy continues to shape a brighter future for our
              community and the Ummah.
            </p>
            <div className="commitment-features">
              <div className="commitment-item">
                <h4>Quality Education</h4>
                <p>Comprehensive curriculum designed for holistic development</p>
              </div>
              <div className="commitment-item">
                <h4>Islamic Values</h4>
                <p>Integrating Islamic principles into every aspect of learning</p>
              </div>
              <div className="commitment-item">
                <h4>Character Building</h4>
                <p>Developing moral character and ethical leadership skills</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
